module.exports = __webpack_public_path__ + "/images/cover-cta-caja-yellow-m.e86fbd8.jpg";